import { render, staticRenderFns } from "./AgencyStudentList.vue?vue&type=template&id=9b0e5702&scoped=true"
import script from "./AgencyStudentList.vue?vue&type=script&lang=js"
export * from "./AgencyStudentList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b0e5702",
  null
  
)

export default component.exports